export default __webpack_public_path__ + "static/media/video-preview.a75c2896.jpg";